<template>
    <div class="c-news-entity">
        <div class="c-news-entity__image">
            <img v-if="entityData.Image.BinaryID" :src="imageUrl" :title="entityData.Image.Alt" />
            <div class="c-news-entity__image-caption" v-if="entityData.Image.Caption.length > 0">
                {{ entityData.Image.Caption }}
            </div>
        </div>
        <div class="c-news-entity_meta">
            <span>
                <i class="xp xp-calendar"></i>
                <span>{{ entityData.Date | dateString }}</span>
            </span>
            <span v-if="entityData.ShowTime">
                <i class="xp xp-clock-o"></i>
                <span>{{ entityData.Date | timeString }}</span>
            </span>
            <span v-if="entityData.Location.length > 0">
                <i class="xp xp-map-marker"></i>
                <span>{{ entityData.Location }}</span>
            </span>
        </div>
        <div class="c-news-entity__teaser" v-html="entityData.Teaser"></div>
    </div>
</template>

<script>
export default {
  props: ['entityData'],
  computed: {
    imageUrl () {
      return this.$xp.content.getImageUrl(this.entityData.Image)
    }
  }
}
</script>
